/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';
// @ts-ignore
import type { UserSettings } from './UserSettings';
// @ts-ignore
import {
// @ts-ignore
    UserSettingsFromJSON,
// @ts-ignore
    UserSettingsFromJSONTyped,
// @ts-ignore
    UserSettingsToJSON,
} from './UserSettings';

/**
 * 
 * @export
 * @interface UserUpdateRequest
 */
export interface UserUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    mobileCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    mobileNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    languageCode: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    role: string;
    /**
     * 
     * @type {Status}
     * @memberof UserUpdateRequest
     */
    status: Status;
    /**
     * 
     * @type {UserSettings}
     * @memberof UserUpdateRequest
     */
    settings?: UserSettings;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    supplierId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    retailerId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    storeId?: string;
}

/**
 * Check if a given object implements the UserUpdateRequest interface.
 */
// @ts-ignore
export function instanceOfUserUpdateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "fullName" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "languageCode" in value;
    isInstance = isInstance && "timezone" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

// @ts-ignore
export function UserUpdateRequestFromJSON(json: any): UserUpdateRequest {
    return UserUpdateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function UserUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserUpdateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'username': json['username'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'email': json['email'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'fullName': json['full_name'],
        'mobileCountryCode': !exists(json, 'mobile_country_code') ? undefined : json['mobile_country_code'],
        'mobileNumber': !exists(json, 'mobile_number') ? undefined : json['mobile_number'],
        'currencyCode': json['currency_code'],
        'languageCode': json['language_code'],
        'timezone': json['timezone'],
        'role': json['role'],
        'status': StatusFromJSON(json['status']),
        'settings': !exists(json, 'settings') ? undefined : UserSettingsFromJSON(json['settings']),
        'organizationId': !exists(json, 'organization_id') ? undefined : json['organization_id'],
        'supplierId': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'retailerId': !exists(json, 'retailer_id') ? undefined : json['retailer_id'],
        'storeId': !exists(json, 'store_id') ? undefined : json['store_id'],
    };
}

// @ts-ignore
export function UserUpdateRequestToJSON(value?: UserUpdateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'username': value.username,
        'password': value.password,
        'email': value.email,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'full_name': value.fullName,
        'mobile_country_code': value.mobileCountryCode,
        'mobile_number': value.mobileNumber,
        'currency_code': value.currencyCode,
        'language_code': value.languageCode,
        'timezone': value.timezone,
        'role': value.role,
        'status': StatusToJSON(value.status),
        'settings': UserSettingsToJSON(value.settings),
        'organization_id': value.organizationId,
        'supplier_id': value.supplierId,
        'retailer_id': value.retailerId,
        'store_id': value.storeId,
    };
}

